import { render } from "./CategoryItem.vue?vue&type=template&id=0fd4a63c&scoped=true"
import script from "./CategoryItem.vue?vue&type=script&lang=js"
export * from "./CategoryItem.vue?vue&type=script&lang=js"

import "@/wwwroot/css/categoryItem.css?vue&type=style&index=0&id=0fd4a63c&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fd4a63c"]])

export default __exports__